import { render, staticRenderFns } from "./word-choose-audio.vue?vue&type=template&id=2ce05b2a&scoped=true&"
import script from "./word-choose-audio.vue?vue&type=script&lang=js&"
export * from "./word-choose-audio.vue?vue&type=script&lang=js&"
import style0 from "./word-choose-audio.vue?vue&type=style&index=0&id=2ce05b2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce05b2a",
  null
  
)

export default component.exports